module.exports = __webpack_public_path__ + "static/media/uncheckedRadioButton.21b4d41f.svg";